import InputGroup from "../input-group/input-group";
const STElevation = ({ loc, onChanged, data: { STElevTo_uV }, minST, maxST }) => (
    <div className="ctrl-input-group-ST">
        <InputGroup
            {...{
                id: "edit.STElev",
                title: loc("report.params.ST_elev_to"),
                val: STElevTo_uV,
                units: loc("units.uV"),
                _key: "STElevTo_uV",
                min: minST,
                max: maxST,
                onChanged
            }}
            clearable
        />
    </div>
);

export default STElevation;
